var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('song-list',{attrs:{"title":((_vm.$time.nowDate()) + " 日推歌曲列表"),"value":_vm.value,"loading":_vm.loading,"itemsPerPage":_vm.itemsPerPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }